export default __webpack_public_path__ + "static/media/js.eab44e6e.svg";